import React from 'react';
import { Outlet } from 'react-router-dom';

interface PaymentOptionsRootPageInterface {}

const PaymentOptionsRootPage: React.FC<PaymentOptionsRootPageInterface> = () => <Outlet />;

export default PaymentOptionsRootPage;
